import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { View, Image } from '@zhike/ti-ui';
import Header from 'components/header';
import { get } from 'lodash';
import { css } from 'aphrodite';
import { tipData } from './constants';
import imgOk from './assets/ok.png';
import styles from './styles';

// 阅读指令
export default class Welcome extends Component {
  // 参数
  static propTypes = {
    step: PropTypes.object.isRequired,
  };

  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  // 模块即将加载
  componentWillMount() {
    Header.config({
      showButtons: ['testStop', 'testNext'],
      isShowTime: false,
    });
  }

  // 渲染进度条
  renderProgress() {
    const { sectionId, examId } = this.props.step;
    const arr = [];
    let nameArr;
    switch (examId) {
      case 1:
        nameArr = ['词汇', '语法', '阅读', '听力', '口语', '写作'];
        break;
      case 2:
        nameArr = ['词汇', '语法', '听力', '阅读', '写作', '口语'];
        break;
      case 56:
        nameArr = ['单项选择', '完形填空', '阅读理解', '数学'];
        break;
      default:
        break;
    }
    for (let k = 0; k <= (examId !== 56 ? 5 : 3); k += 1) {
      if (k < sectionId) {
        arr.push('ok');
      } else if (k === sectionId) {
        arr.push('being');
      } else {
        arr.push('notStart');
      }
    }
    return (
      <View className={styles.progressContainer}>
        <View className={styles.progress}>
          <View className={styles.progressLine} />
          {
            arr &&
            arr.map((item, index) => (
              <View key={index} className={styles.progressOne}>
                <View
                  className={styles.progressCircle}
                >
                  {
                    item === 'ok' &&
                    <Image
                      className={styles.imgOk}
                      src={`${imgOk}`}
                    />
                  }
                  {
                    item === 'being' &&
                    <View
                      className={styles.circle}
                    >
                      <View
                        className={styles.circle1}
                      />
                    </View>
                  }
                  {
                    item === 'notStart' &&
                    <View
                      className={styles.circleGray}
                    />
                  }
                </View>
                <span className={css(styles.progressName)}>{nameArr[index]}</span>
              </View>),
            )
          }
        </View>
      </View>
    );
  }
  // 渲染
  render() {
    const { sectionId, examId } = this.props.step;
    let tipInfo;
    let tipInfo1;
    if (sectionId !== 0 && sectionId !== 5) {
      tipInfo = tipData[examId] && tipData[examId][sectionId];
      tipInfo1 = tipData[examId] && tipData[examId][sectionId - 1];
    }
    return (
      <View className={styles.container}>
        <Image
          src={require(`components/assets/${sectionId === 0 ? 'default' : 'success'}.png`)}
          style={{ width: '80px', height: '80px', marginTop: '80px' }}
        />
        {
          sectionId === 0 &&
          <div
            style={{ marginTop: '20px' }}
          >
            首先是<span className={css(styles.tip)}>{get(tipData, `${examId}.${sectionId}.0`)}</span>测试，共<span className={css(styles.tip)}>{get(tipData, `${examId}.${sectionId}.1`)}</span>道题,
            建议用时<span className={css(styles.tip)}>{get(tipData, `${examId}.${sectionId}.2`)}</span>分钟,加油哦～
          </div>
        }
        {
          sectionId !== 0 && sectionId !== 5 &&
          <View
            style={{ marginTop: '20px' }}
          >
            <div style={{ textAlign: 'center' }}>恭喜你已完成<span>{tipInfo1[0]}</span>部分</div>
            <div className={css(styles.text)}>
              接下来是<span className={css(styles.tip)}>{tipInfo[0]}</span>部分，
              共<span className={css(styles.tip)}>{tipInfo[1]}</span>道题,
              建议用时<span className={css(styles.tip)}>{tipInfo[2]}</span>分钟
            </div>
          </View>
        }
        {
          sectionId === 5 &&
          <div
            className={css(styles.text)}
            style={{ marginTop: '20px' }}
          >
            恭喜你已完成口语部分，接下来是本次测试的最后一部分 --- 写作
            共<span className={css(styles.tip)}>15</span>道题，建议用时<span className={css(styles.tip)}>40</span>分钟
          </div>
        }
        <View
          style={{ marginTop: '80px' }}
        >
          { this.renderProgress() }
        </View>
      </View>
    );
  }
}




// WEBPACK FOOTER //
// ./src/components/testPages/welcome/index.js